export default ({ firstName, lastName, email, ...formData }) => ({
  firstName: firstName.trim(),
  lastName: lastName.trim(),
  email: email.trim(),
  ...formData,
});
